import { TApplicationState } from '../../types/redux';

export function genplanSelector(state: TApplicationState) {
  return state.newbuilding.genplan;
}
